if (!customElements.get('product-configurator')) {
    customElements.define(
        'product-configurator',
        class ProductConfigurator extends HTMLElement {
            constructor() {
                super();

                this.openBtn = this.querySelector('.product-configurator--actions-open');
                this.overlay = this.querySelector('.product-configurator--overlay');
                this.modal = this.querySelector('.product-configurator--modal');
                this.closeModal = this.querySelector('.product-configurator--modal-close');
                this.takeConfigBtn = this.querySelector('.take-configuration');
                this.submitAlertEl = this.querySelector('.product-configurator--submit-alert');
                this.inquiryForm = this.querySelector('.product-configurator--inquiry-form');
                this.inquirySubmitBtn = this.querySelector('.product-configurator--inquiry-submit');
                this.inquiryBodyField = this.querySelector('[data-configurator-inquiry-body]');
                this.locale = this.normalizeLocale(this.dataset.locale || document.documentElement.lang || 'de');
                this.translations = {
                    selectPlaceholder: this.dataset.i18nSelectPlaceholder || 'Please select...',
                    inquiryIncomplete: this.dataset.i18nInquiryIncomplete || 'Please configure the product before sending the inquiry.',
                    inquiryProduct: this.dataset.i18nInquiryProduct || 'Product',
                    inquiryProductUrl: this.dataset.i18nInquiryProductUrl || 'Product URL',
                    inquirySummaryTitle: this.dataset.i18nInquirySummaryTitle || 'Selected configuration options:',
                    inquiryEmptySummary: this.dataset.i18nInquiryEmptySummary || 'No configuration options selected.',
                    alertSelectOption: this.dataset.i18nAlertSelectOption || 'Please make a selection',
                    alertSelectColor: this.dataset.i18nAlertSelectColor || 'Please select at least one color',
                    alertSelectValue: this.dataset.i18nAlertSelectValue || 'Please select a value',
                    surchargePerUnitSuffix: this.dataset.i18nSurchargePerUnitSuffix || ' / piece*'
                };
                if(this.inquirySubmitBtn){
                    this.inquirySubmitBtn.setAttribute('disabled', 'disabled');
                }

                this.navSelection = this.querySelector('.navigation-selection');
                this.prevBtn = this.querySelector('.product-configurator--navigation-btn-left');
                this.nextBtn = this.querySelector('.product-configurator--navigation-btn-right');
                
                let configJson = this.querySelector('#configurator-config').innerText;
                this.config = null;
                try {
                    this.config = JSON.parse(configJson);
                } catch (e) {
                    return;
                }
                this.templateConfig = this.config.template;
                this.isStepByStep = this.templateConfig['step_by_step_configurator'];
                this.config = this.config.data;

                this.config.sort((a, b) => Number(a.position) - Number(b.position));

                this.optionProducts = null;

                // Model Elements
                this.optionsEl = this.querySelector('.product-configurator--options');

                // Flags
                this.renderConfigurationFlag = false;

                // Surcharges
                this.surchargeEl = this.querySelector('.product-configurator--surcharges');
                this.basePrice = this.getAttribute('data-base-price');
                this.currencySymbol = this.getAttribute('data-currency-symbol');
                this.hidePrice = this.getAttribute('data-hide-price') === 'true';
                this.surchargesSelectionTemplate = this.querySelector('#surcharges-selection');
                this.surchargesItemTemplate = this.surchargesSelectionTemplate.content.querySelector('#surcharges-item');
                this.surchargesSelectionsEl = this.querySelector('.surcharges--overview-selections');
                this.surchargesBasePrice = this.querySelector('.surcharges--overview-base-price');
                this.surchargesOverviewPrice = this.querySelector('.surcharges--overview-total-price');
                this.surchargesTotalPrice = this.querySelector('.product-configurator--surcharges-total-price');

                // Surcharge outside
                this.surchargeOutsideEl = null;

                // Selection tracking
                this.selectionTracking = [];

                this.init();

            }
            
            async init(){
                this.openBtn.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.show();
                });

                this.overlay.addEventListener('click', (evt) => {   
                    evt.preventDefault();
                    this.hide();
                });
                this.closeModal.addEventListener('click', (evt) => {   
                    evt.preventDefault();
                    this.hide();
                });

                this.takeConfigBtn.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    this.hide();
                });

                if(this.inquiryForm){
                    this.inquiryForm.addEventListener('submit', (evt) => {
                        this.handleInquirySubmit(evt);
                    }, true);
                }

                const templateDisplayName = this.getLocalizedField(this.templateConfig, 'display_name');
                const templateDescription = this.getLocalizedField(this.templateConfig, 'description');
                this.querySelector(".product-configurator--heading").innerText = templateDisplayName;
                this.querySelector(".product-configurator--modal-heading").innerText = templateDisplayName;

                if(templateDescription != ''){
                    this.querySelector(".product-configurator--description").insertAdjacentHTML('afterbegin', templateDescription);
                }

                let additionalClass = (this.isStepByStep == '1') ? 'step-by-step' : 'one-page';
                this.classList.add(additionalClass);

                this.config.forEach((option) => {
                    this.selectionTracking.push({
                        "name": option['name'],
                        "displayName": this.getLocalizedField(option, 'name'),
                        "required": option['required'],
                        "type": option['type'],
                        "selected": []
                    });
                });

                this.openBtn.disabled = true;

                this.optionProducts = await this.getOptionProducts();

                this.setAttribute("init", 1);
                this.openBtn.disabled = false;
                if(this.inquirySubmitBtn){
                    this.inquirySubmitBtn.removeAttribute('disabled');
                }

                if(this.isStepByStep == '0'){
                    this.show();
                    this.renderResetAll();
                    this.collaspeEvent();
                }else{
                    this.surchargeOutsideEl = this.querySelector('.product-configurator--surcharge-outside');
                }

            }

            show() {
                this.overlay.classList.add('active');
                this.modal.classList.add('active');

                if(!this.renderConfigurationFlag){
                    this.renderContent();
                    this.renderNavigation();
                    this.renderSurchares();
                    this.renderConfigurationFlag = true;
                }
            }

            hide() {
                this.overlay.classList.remove('active');
                this.modal.classList.remove('active');
                this.renderSurchargeOutside();

                this.submitAlertEl.classList.remove('showed');
            }

            renderSurchares(){
                if(this.hidePrice){
                    return;
                }

                let totalPrice = 0;
                this.surchargesSelectionsEl.innerHTML = '';
                this.surchargesBasePrice.innerText = this.basePrice + ' ' + this.currencySymbol + '*';

                let basePriceFormatted = this.formatEuropeanNumber(this.basePrice);
                totalPrice += basePriceFormatted;

                // Configurator

                for(const option of this.selectionTracking){
                    if(option['selected'].length > 0){
                        let selectionHavingSurcharge = false;
                        const renderData = [];

                        option['selected'].forEach((item) => {
                            if(item['surcharge'] != '0'){
                                selectionHavingSurcharge = true;
                                let surchargeFormatted = this.formatEuropeanNumber(item['surcharge']);
                                totalPrice += surchargeFormatted;
                                renderData.push({
                                    'name': item['value'],
                                    'surcharge': this.formatToEuropeanNumber(surchargeFormatted)
                                });
                            }
                        });

                        if(selectionHavingSurcharge){
                            // Render surcharges
                            const surchargeSelection = this.surchargesSelectionTemplate.content.cloneNode(true);
                            renderData.forEach((item) => {
                                surchargeSelection.querySelector('.surcharges--overview-selection-option').innerText = option['displayName'] || option['name'];
                                const surchargeItem = this.surchargesItemTemplate.content.cloneNode(true);
                                surchargeItem.querySelector('.surcharges--overview-selection-item-name').innerText = item['name'];
                                surchargeItem.querySelector('.surcharges--overview-selection-item-price').innerText = item['surcharge'];

                                surchargeSelection.appendChild(surchargeItem);

                            });
                            this.surchargesSelectionsEl.appendChild(surchargeSelection);

                        }
                    }
                }

                // Overview total price
                this.surchargesOverviewPrice.innerText = this.formatToEuropeanNumber(totalPrice);

                // Total Surcharges
                this.surchargesTotalPrice.innerText = this.formatToEuropeanNumber(totalPrice);
            }

            renderSurchargeOutside(){
                if(this.surchargeOutsideEl){
                    this.surchargeOutsideEl.innerHTML = '';
                    const cloneSurcharge = this.surchargeEl.cloneNode(true);
                    this.surchargeOutsideEl.appendChild(cloneSurcharge);
                }
            }

            renderContent() {
                const configurationOptionTemplate = this.querySelector('#configurator-option');
                const configurationItemTemplate = configurationOptionTemplate.content.querySelector('#configurator-item');

                let index = 0;

                this.config.forEach((option) => {

                    const optionItem = configurationOptionTemplate.content.cloneNode(true);
                    const optionDisplayName = this.getLocalizedField(option, 'name');
                    // Heading
                    const optionHeadingEl = optionItem.querySelector('.configurator--option-heading');
                    optionHeadingEl.innerText = optionDisplayName;
                    if(this.isRequiredOption(option['required'])){
                        const requireText = document.createElement('small');
                        requireText.innerText = '**';
                        optionHeadingEl.appendChild(requireText);
                    }


                    const optionEl = optionItem.querySelector('.product-configurator--option');
                    const optionItemsEl = optionItem.querySelector('.configurator--option-items');
                    optionEl.setAttribute("id", "product-configurator--option-" + index );
                    optionEl.setAttribute('data-option-type', option['type']);
                    optionEl.setAttribute('data-option-name', option['name']);
                    optionEl.setAttribute('data-option-display-name', optionDisplayName);

                    if(index == 0){
                        optionEl.classList.add('active');
                    }

                    if(this.isStepByStep == '0' && this.isRequiredOption(option['required'])){
                        optionEl.classList.add('collaspe-active');

                    }

                    let selectEl = null;

                    if(option['type'] == 'multiselect' || option['type'] == 'select'){
                        // Select Element
                        selectEl = document.createElement('select');
                        if(option['type'] == 'multiselect'){
                            selectEl.setAttribute('multiple','multiple');
                            selectEl.setAttribute('size', option['values'].length);
                        }

                        selectEl.classList.add('configurator--option-item-' + option['type']);

                        selectEl.setAttribute('name', option['name']);
                        selectEl.setAttribute('data-option-name', option['name']);

                        if(option['type'] == 'select'){
                            const defaultOption = document.createElement('option');
                            defaultOption.setAttribute('value', '');
                            defaultOption.setAttribute('disabled', 'disabled');
                            defaultOption.setAttribute('selected', 'selected');
                            defaultOption.innerText = this.translations.selectPlaceholder;
                            selectEl.appendChild(defaultOption);
                        }

                        selectEl.addEventListener('change', (evt) => {
                            this.updateTracking(evt);
                            this.renderSurchares();
                        });

                        optionItemsEl.appendChild(selectEl);

                        // Add icon
                        optionItemsEl.insertAdjacentHTML('beforeend', `<i class="fa-solid fa-chevron-down"></i>`);
                    }

                    optionEl.classList.add('configurator--option-type-' + option['type']);

                    option['values'].sort((a, b) => Number(a.position) - Number(b.position));

                    option['values'].forEach((item) => { 
                        const itemDisplayName = this.getLocalizedField(item, 'name');
                        if(selectEl){
                            // Select options
                            const optionEl = document.createElement('option');
                            optionEl.setAttribute('value', itemDisplayName);
                            optionEl.setAttribute('data-option-name', option['name']);
                            optionEl.setAttribute('data-value-name', itemDisplayName);
                            optionEl.setAttribute('data-surcharge', item['surcharge'].replace('.', ','));
                            optionEl.setAttribute('data-surcharge-handle', item['surcharge_handle']);
                            optionEl.setAttribute('data-option-id', "product-configurator--option-" + index);
                            let optionName = itemDisplayName;
                            if(!this.hidePrice && item['surcharge'] != '0'){
                                optionName = optionName + ' (+ ' + item['surcharge'] + ' ' + this.currencySymbol + this.translations.surchargePerUnitSuffix + ')'
                            }
                            optionEl.innerText = optionName;

                            selectEl.appendChild(optionEl);
                        }else{

                            const itemEl = configurationItemTemplate.content.cloneNode(true);

                            // Input Element
                            const optionNameHandle = this.getOptionName(option['name'], item['name'], true);
                            const itemNameHandle = this.getOptionName(option['name'], item['name']);

                            const inputEl = itemEl.querySelector('input');
                            inputEl.setAttribute('name', optionNameHandle);
                            inputEl.setAttribute('id', itemNameHandle);

                            const inputType = (option['allows_multiple_selection'] == '1') ? 'checkbox' : 'radio';
                            inputEl.setAttribute('type', inputType);

                            inputEl.setAttribute('data-option-name', option['name']);
                            inputEl.setAttribute('data-value-name', itemDisplayName);
                            inputEl.setAttribute('data-surcharge', item['surcharge'].replace('.', ','));
                            inputEl.setAttribute('data-surcharge-handle', item['surcharge_handle']);
                            inputEl.setAttribute('data-option-id', "product-configurator--option-" + index);

                            inputEl.addEventListener('change', (evt) => {
                                this.updateTracking(evt);
                                this.renderSurchares();
                            });

                            // display element: not set for radio
                            const displayEl = itemEl.querySelector('.configurator--option-item-display');
                            switch(option['type']) {
                                default:
                                    break;
                                case 'colorselect':
                                    displayEl.style.backgroundColor = item['value'];
                                    break;
                                case 'imageselect':
                                    if(this.optionProducts && item['surcharge'] != '0'){
                                        const itemHandle = item['surcharge_handle'];
                                        if(itemHandle){
                                            const optionProductObj = this.optionProducts.find(op => {
                                                return op['handle'] == itemHandle;
                                            });

                                            if(optionProductObj){
                                                const imgEl = document.createElement('img');
                                                imgEl.setAttribute('src', item['value'] ?? optionProductObj['data']['img']);
                                                imgEl.setAttribute('alt', itemDisplayName);
                                                displayEl.appendChild(imgEl);
                                            }
                                        }
                                    }else{
                                        const imgEl = document.createElement('img');
                                        imgEl.setAttribute('src', item['value']);
                                        imgEl.setAttribute('alt', itemDisplayName);
                                        displayEl.appendChild(imgEl);
                                    }
                                    break;
                            }

                            // Label element
                            const labelEl = itemEl.querySelector('.configurator--option-item-label');
                            labelEl.setAttribute('for', itemNameHandle);

                            itemEl.querySelector('.configurator--option-item-text').innerText = itemDisplayName;
                            if(!this.hidePrice && item['surcharge'] != '0' && item['surcharge_handle']){
                                let surcharge = parseFloat(item['surcharge']);
                                surcharge = surcharge.toFixed(2);
                                itemEl.querySelector('.configurator--option-item-surchage').innerText = '(+ ' + surcharge + ' ' + this.currencySymbol + this.translations.surchargePerUnitSuffix + ')';
                            }

                            // Add item to option
                            optionItemsEl.appendChild(itemEl);
                        }

                    });

                    // Reset btn
                    const resetBtn = optionItem.querySelector('.configurator--modal-reset');
                    resetBtn.setAttribute('data-option-id', "product-configurator--option-" + index);
                    resetBtn.setAttribute('data-option-name', option['name']);
                    resetBtn.addEventListener('click', (evt) => { 
                        const optionContainer = evt.currentTarget.closest('.product-configurator--option');
                        if(optionContainer.getAttribute('data-option-type') == 'multiselect'){
                            const selectEl = optionContainer.querySelector('select');
                            selectEl.querySelectorAll('option').forEach((option) => {
                                option.selected = false;
                            });
                        }else if(optionContainer.getAttribute('data-option-type') == 'select'){
                            const selectEl = optionContainer.querySelector('select');
                            selectEl.selectedIndex = 0;
                        }else{
                            optionContainer.querySelectorAll('input').forEach((input) => {
                                if(input.getAttribute('type') == 'radio' || input.getAttribute('type') == 'checkbox'){
                                    input.checked = false;
                                }
                            });
                        }

                        this.updateTracking(evt);
                        this.renderSurchares();
                    });

                    // Add option to configurator
                    this.optionsEl.appendChild(optionItem);
                    index++;
                });

                this.last = index - 1;
            }

            renderNavigation() {
                let index = 0;
                this.config.forEach((option) => {
                    const optionEL = document.createElement('option');
                    optionEL.value = index;
                    let optionLabel = this.getLocalizedField(option, 'name');
                    if(this.isRequiredOption(option['required'])){
                        optionLabel += ' **';
                    }
                    optionEL.innerText = optionLabel;

                    if(index == 0){
                        optionEL.setAttribute('selected', 'selected');
                    }

                    this.navSelection.appendChild(optionEL);

                    index++;
                });

                // Selection Event

                this.currSelect = 0;

                this.navSelection.addEventListener('change', (evt) => {
                    const selectedIndex = parseInt(evt.currentTarget.value);
                    this.selectionEvent(selectedIndex);
                });

                // Buttons Event
                this.updateNavBtns(0);

                [this.prevBtn, this.nextBtn].forEach((btn) => {  
                    btn.addEventListener('click', (evt) => {
                        const selectedIndex = evt.currentTarget.getAttribute('data-value');
                        this.selectionEvent(selectedIndex);
                    });
                });
            }

            renderResetAll(){
                const configuratorResetAllTemplate = this.querySelector('#configurator-reset-all');
                const resetAllEl = configuratorResetAllTemplate.content.cloneNode(true);

                const resetAllBtn = resetAllEl.querySelector('.configurator--modal-reset-all');

                resetAllBtn.addEventListener('click', (evt) => {
                    this.querySelectorAll('.configurator--modal-reset').forEach((el) => {
                        el.click();
                    });

                    this.updateTracking(evt);
                    this.renderSurchares();
                });

                this.optionsEl.appendChild(resetAllEl);
            }

            submitAction(){
                if(!this.config){
                    return null;
                }
                const alertItemsEl = this.submitAlertEl.querySelector('.product-configurator--alert-items');
                alertItemsEl.innerHTML = '';

                // get all required fields that not have selection
                let requiredCheck = this.getIncompleteRequiredOptions();

                if(requiredCheck.length > 0){
                    const alertItemTemplate = this.querySelector("#configurator-alert-item");
                    requiredCheck.forEach(item => {
                        const alertItemEl = alertItemTemplate.content.cloneNode(true);
                        alertItemEl.querySelector('.product-configurator--alert-item').innerText = this.getAlertMsg(item['type']);
                        alertItemsEl.appendChild(alertItemEl);
                    });

                    this.submitAlertEl.classList.add('showed');
                    return false;
                }else{
                    this.submitAlertEl.classList.remove('showed');
                }

                return true;
            }

            handleInquirySubmit(evt){
                if(this.getAttribute("init") != 1){
                    this.blockInquirySubmit(evt);
                    return;
                }

                if(!this.isConfigurationComplete()){
                    this.blockInquirySubmit(evt);
                    if(this.hasConfiguratorSelection()){
                        this.submitAction();
                    }else{
                        this.showSubmitAlert([this.translations.inquiryIncomplete]);
                    }
                    this.submitAlertEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    return;
                }

                this.populateInquiryFields();
            }

            showSubmitAlert(messages){
                const alertItemsEl = this.submitAlertEl.querySelector('.product-configurator--alert-items');
                const alertItemTemplate = this.querySelector("#configurator-alert-item");
                alertItemsEl.innerHTML = '';

                messages.forEach(message => {
                    const alertItemEl = alertItemTemplate.content.cloneNode(true);
                    alertItemEl.querySelector('.product-configurator--alert-item').innerText = message;
                    alertItemsEl.appendChild(alertItemEl);
                });

                this.submitAlertEl.classList.add('showed');
            }

            blockInquirySubmit(evt){
                evt.preventDefault();
                evt.stopPropagation();
                if(evt.stopImmediatePropagation){
                    evt.stopImmediatePropagation();
                }
            }

            isConfigurationComplete(){
                if(!this.config){
                    return false;
                }

                return this.getIncompleteRequiredOptions().length === 0 && this.hasConfiguratorSelection();
            }

            getIncompleteRequiredOptions(){
                return this.selectionTracking.filter((item) => {
                    return this.isRequiredOption(item.required) && item.selected.length == 0;
                });
            }

            hasConfiguratorSelection(){
                return this.selectionTracking.some((item) => {
                    return item.selected.length > 0;
                });
            }

            isRequiredOption(requiredValue){
                return requiredValue === true || requiredValue === 1 || requiredValue === '1' || requiredValue === 'true';
            }

            populateInquiryFields(){
                if(!this.inquiryForm || !this.inquiryBodyField){
                    return;
                }

                const productTitle = this.inquirySubmitBtn?.getAttribute('data-product-title') || document.querySelector('.product-single__title')?.innerText?.trim() || '';
                const productUrl = this.inquirySubmitBtn?.getAttribute('data-product-url') || window.location.href;
                const configurationData = this.getInquiryConfigurationData();
                const configurationSummary = this.getInquiryConfigurationSummary(configurationData);

                this.inquiryBodyField.value = [
                    this.translations.inquiryProduct + ': ' + productTitle,
                    this.translations.inquiryProductUrl + ': ' + productUrl,
                    '',
                    this.translations.inquirySummaryTitle,
                    configurationSummary || this.translations.inquiryEmptySummary
                ].join('\n');
            }

            getInquiryConfigurationData(){
                return this.selectionTracking.map(option => {
                    return {
                        name: option.name,
                        displayName: option.displayName,
                        required: option.required,
                        type: option.type,
                        selected: option.selected.map(selection => {
                            return {
                                value: selection.value
                            };
                        })
                    };
                });
            }

            getInquiryConfigurationSummary(configurationData){
                return configurationData
                    .filter(option => option.selected.length > 0)
                    .map(option => {
                        const selectedValues = option.selected.map(selection => selection.value).join(', ');
                        return (option.displayName || option.name) + ': ' + selectedValues;
                    })
                    .join('\n');
            }

            normalizeLocale(locale){
                return (locale || '').toLowerCase().split('-')[0];
            }

            getLocalizedField(source, fieldName){
                const translatedValue = source?.translations?.[this.locale]?.[fieldName];
                if(typeof translatedValue === 'string' && translatedValue.trim() !== ''){
                    return translatedValue;
                }

                return source?.[fieldName] ?? '';
            }

            selectionEvent(selectedIndex){
                const selectedOption = this.optionsEl.querySelector('#product-configurator--option-' + this.currSelect);
                const optionName = selectedOption.getAttribute('data-option-name');
                const optionType = selectedOption.getAttribute('data-option-type');

                // check if current option is required and not selected
                const checkResult = this.selectionTracking.find((item) => {
                    return item.name == optionName && this.isRequiredOption(item['required']) && item['selected'].length == 0;
                });

                if(checkResult){
                    let alertMsg = this.getAlertMsg(optionType)

                    this.navSelection.value = this.currSelect;
                    selectedOption.querySelector('.configurator--option-alert').innerText = alertMsg;

                }else{
                    selectedOption.querySelector('.configurator--option-alert').innerText = '';
                    this.updateSelection(selectedIndex);
                    this.updateNavBtns(selectedIndex);
                    this.navSelection.value = selectedIndex;
                }
            }

            getAlertMsg(optionType){
                let alertMsg = this.translations.alertSelectOption;
                if(optionType == 'colorselect'){
                    alertMsg = this.translations.alertSelectColor;
                }else if(optionType == 'radio'){
                    alertMsg = this.translations.alertSelectValue;
                }

                return alertMsg;
            }

            collaspeEvent(){
                this.querySelectorAll('.configurator--option-heading').forEach((el) => {
                    el.addEventListener("click", (evt) => {
                        const element = evt.currentTarget;
                        element.closest('.product-configurator--option').classList.toggle('collaspe-active');
                    });
                });
            }

            updateSelection(selectedIndex){
                const selectedOption = this.optionsEl.querySelector('#product-configurator--option-' + selectedIndex);
                this.optionsEl.querySelectorAll('.product-configurator--option').forEach((option) => {
                    option.classList.remove('active');
                });
                selectedOption.classList.add('active');
            }

            updateNavBtns(selectedIndex){
                this.currSelect = parseInt(selectedIndex);

                if(this.currSelect == 0){
                    this.prevBtn.disabled = true;
                    this.prevBtn.setAttribute('data-value', this.currSelect);
                }else if(this.currSelect == 1){
                    this.prevBtn.setAttribute('data-value', 0);
                    this.prevBtn.disabled = false;
                }else{
                    this.prevBtn.setAttribute('data-value', this.currSelect - 1);
                    this.prevBtn.disabled = false;
                }
                
                if(this.currSelect == this.last){
                    this.nextBtn.disabled = true;
                    this.nextBtn.setAttribute('data-value', this.currSelect);
                }else if(this.currSelect == this.last - 1){
                    this.nextBtn.setAttribute('data-value', this.last);
                    this.nextBtn.disabled = false;
                }else{
                    this.nextBtn.setAttribute('data-value', this.currSelect + 1);
                    this.nextBtn.disabled = false;
                }
            }

            updateTracking(evt){
                const newValues = [];
                let optionName = null;
                const currTarget = evt.currentTarget;

                if(currTarget.type == 'select-multiple'){
                    const selectOptions = currTarget.selectedOptions;
                    optionName = currTarget.getAttribute('data-option-name');
                    Array.from(selectOptions).forEach((option) => {
                        newValues.push({
                            'value': option.getAttribute('data-value-name'),
                            'surcharge': option.getAttribute('data-surcharge'),
                            'surcharge_handle': option.getAttribute('data-surcharge-handle')
                        });
                    });
                }else if(currTarget.type == 'select-one'){
                    const selectedOption = currTarget.options[currTarget.selectedIndex];
                    optionName = currTarget.getAttribute('data-option-name');
                    if(optionName){
                        newValues.push({
                            'value': selectedOption.getAttribute('data-value-name'),
                            'surcharge': selectedOption.getAttribute('data-surcharge'),
                            'surcharge_handle': selectedOption.getAttribute('data-surcharge-handle'),
                        });
                    }
                }else{
                    const optionId = currTarget.getAttribute('data-option-id');
                    optionName = currTarget.getAttribute('data-option-name');
    
                    const inputEls = this.optionsEl.querySelectorAll('#' + optionId + ' input');
    
                    inputEls.forEach((input) => {
                        if(input.checked){
                            newValues.push({
                                'value': input.getAttribute('data-value-name'),
                                'surcharge': input.getAttribute('data-surcharge'),
                                'surcharge_handle': input.getAttribute('data-surcharge-handle')
                            });
                        }
                    });
                }

                let selected = this.selectionTracking.find((item) => {
                    return item.name == optionName;
                });

                if(selected){
                    selected.selected = newValues;
                }

                // find if not having selection for required options
                const findResult = this.selectionTracking.find((item) => { 
                    return this.isRequiredOption(item.required) && item.selected.length == 0;
                });

                if(!findResult){
                    this.takeConfigBtn.removeAttribute('disabled');
                }else{
                    this.takeConfigBtn.setAttribute('disabled', 'disabled');
                }

            }

            getOptionName(optionName, itemName, onlyOptionName = false) {
                const optionNameFormatted = optionName.trim().replace(/[^a-zA-Z0-9\s]/g, "").toLowerCase().replace(/\s+/g, "-");
                if(onlyOptionName){
                    return optionNameFormatted;
                }
                const itemNameFormatted = itemName.trim().replace(/[^a-zA-Z0-9\s]/g, "").toLowerCase().replace(/\s+/g, "-");
                return `${optionNameFormatted}-${itemNameFormatted}`;
            }

            async getOptionProducts(){
                let page = 1;
                let allProducts = [];
                let hasMore = true;

                while (hasMore) {
                    const response = await fetch(`/collections/option-products?view=products_data&page=${page}`);
                    const text = await response.text();

                    let data = [];
                    try {
                        data = JSON.parse(text).collection;
                    } catch (e) {
                        console.warn("Parsing failed, maybe no products on page", page);
                        data = [];
                    }

                    if (data.length === 0) {
                        hasMore = false;
                    } else {
                        allProducts = allProducts.concat(data);
                        page++;
                    }
                }

                return allProducts;
            }

            prepareCartConfigurator(){
                if(!this.optionProducts) return;

                const optionProductIdList = [];
                const optionProductHandleList = [];

                this.selectionTracking.forEach(option => {
                    if(option.selected.length != 0){
                        option.selected.forEach(selection => {
                            if(selection['surcharge'] != '0' && selection['surcharge_handle'] != 'null'){
                                optionProductHandleList.push(selection['surcharge_handle']);
                            }
                        });
                    }
                });

                optionProductHandleList.forEach(handle => {
                    const optionProductObj = this.optionProducts.find(item => {
                        return item['handle'] == handle;
                    });

                    if(optionProductObj){
                        optionProductIdList.push(optionProductObj['data']['variant_id']);
                    }
                });

                return optionProductIdList;
            }

            getOptionHandle(name, surchage){
                let handle = name.trim().replace(/[^a-zA-Z0-9\s]/g, "").toLowerCase().replace(/\s+/g, "-");
                surchage = surchage.replace(".", "-");
                surchage = surchage.replace(",", "-");
                handle += "-" + surchage;
                return handle;
            }

            getSelectionTracking(){
                return this.selectionTracking;
            }

            formatEuropeanNumber(str) {
                return parseFloat(str.replace('.', '').replace(',', '.'));
            }

            formatToEuropeanNumber(num) {
                const [intPart, decPart] = num
                                        .toFixed(2)
                                        .split('.');

                const formattedInt = intPart.length > 3
                ? intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                : intPart;

                let formattedNum = `${formattedInt},${decPart}`;

                return formattedNum + ' ' + this.currencySymbol + '*';
            }
        }
    );
}
  
